<script setup lang="ts">
import type { Icon } from "@kippie/ui";

const items = ref<{ icon: Icon; text: string }[]>([
	{ icon: "shopping-bag", text: "Al je bestellingen op één plek" },
	{ icon: "percent", text: "Exclusieve kortingen" },
	{ icon: "heart", text: "Je favoriete producten opgeslagen voor jou." },
	{ icon: "delivery", text: "Eenvoudig en snel afrekenen en bezorgen" }
]);
</script>

<template>
	<KippieUspList title="De voordelen die onze familieleden hebben" chicken class="bg-white self-start">
		<ul class="space-y-4 font-medium">
			<li
				v-for="item in items"
				:key="item.text"
				class="border-b border-brown border-dashed pb-4 last:border-none last:pb-0 flex gap-x-4"
			>
				<SvgIcon :name="item.icon" class="min-w-[24px]" />
				<p class="text-sm leading-6">
					{{ item.text }}
				</p>
			</li>
		</ul>
	</KippieUspList>
</template>
